import { IApplicationState } from '../../types/redux';

export const isErrorSelector = (state: IApplicationState): boolean => {
  return state.consultantCianChat.isError;
};
